import { z } from 'zod';

export const listCountriesGetResponseSchema = z.object({
  data: z.object({ countries: z.array(z.object({ label: z.string(), value: z.string() })).optional() }),
  response: z.object({ date: z.string(), messages: z.array(z.string()), status: z.number(), type: z.string() }),
});
